import { useCreateProjectIndicationStore } from 'store/local/projectCreateindication';
import useCheckOneInput from '../useCheckOneInput';
import { MouseEvent, useEffect } from 'react';
import { getJawByToothNumber } from 'lib/clinic/library';
import { ITooth, TDentalArch } from 'lib/types/clinic/projectTypes';

export const useCreateProjectPim = () => {
  // SECTION: variable
  const { teeth, setTeeth, tooth, setTooth, pimNormalSet } = useCreateProjectIndicationStore();

  const upperJawChecked = useCheckOneInput(true);
  const lowerJawChecked = useCheckOneInput(true);

  // SECTION: function
  const handleCheckChange = (e: any, jaw: TDentalArch) => {
    const checked = e.target?.checked;

    if (checked) {
      pimNormalSet.add(jaw);
    } else {
      pimNormalSet.delete(jaw);
    }

    if (jaw === 'upper') {
      upperJawChecked.onChange(e);
    }
    if (jaw === 'lower') {
      lowerJawChecked.onChange(e);
    }

    const newTooth: ITooth = checked
      ? { implantLibrary: undefined, pimType: 'normal', implantType: 9 }
      : { implantLibrary: undefined, pimType: 'scanbody', implantType: 8 };

    setTooth(prev => {
      return {
        ...prev,
        ...newTooth,
        default: { ...prev?.default, situScan: { value: checked ? 1 : 0, isSavedLast: false } },
      };
    });
    setTeeth(prev =>
      prev.map(prevItem => {
        const newDefaultOption = {
          ...prevItem.default,
          situScan: { value: checked ? 1 : 0, isSavedLast: false },
        };

        if (getJawByToothNumber(prevItem.number) === jaw) {
          return { ...prevItem, ...newTooth, default: newDefaultOption };
        } else {
          return prevItem;
        }
      }),
    );
  };

  // SECTION: side effect
  // EFFECT: 최초 렌더링 시
  useEffect(() => {
    if (!teeth) return;

    const scanbodyTeeth = teeth.filter(tooth => tooth.pimType === 'scanbody');

    if (getJawByToothNumber(scanbodyTeeth[0]?.number) === 'upper') {
      upperJawChecked.setValue(false);
      pimNormalSet.delete('upper');
    }
    if (getJawByToothNumber(scanbodyTeeth[0]?.number) === 'lower') {
      lowerJawChecked.setValue(false);
      pimNormalSet.delete('lower');
    }
  }, []);

  return { upperJawChecked, lowerJawChecked, onCheckChange: handleCheckChange };
};
